<template>
  <div :class="$style.root">
    <Stepper
      :total="maxQuestion"
      :current="currentStep"
    />
    <template v-if="question">
      <Question :symbols="question.group.symbols" bgColor="#cfecf8cc" :masks="correctChoices">
        <template v-slot:after v-if="hasAudio">
          <SpeakerIcon @click="audioPlay()" :size="60" />
        </template>
      </Question>
      <Choices :aside="aside" :readOnly="readOnly">
        <template v-if="!readOnly">
          <FormSimilarChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            @click="canSelect ? reSelect(n) : null"
            :isAnswer="showAnswer ? isCorrectAnswer(n) : null"
          />
        </template>
        <template v-if="readOnly">
          <FormSimilarChoice
            v-for="(choice, n) in choices"
            :key="choice.id"
            :active="isSelected(n)"
            :word="choice.word"
            :isAnswer="isCorrectAnswer(n)"
          />
        </template>
      </Choices>
      <template v-if="!readOnly">
        <NextButton
          v-if="canProceed"
          @click="submitAnswer"
          :loading="isLoading"
          :disabled="disableNextButton"
        />
      </template>
      <template v-if="readOnly">
        <NextButton
          v-if="canReadNext"
          @click="readNextStep"
          noAni
        />
        <PrevButton
          v-if="canReadPrev"
          @click="readPrevStep"
          noAni
        />
      </template>
    </template>
  </div>
</template>

<script>
import exerciseMixin from '@/mixins/exercise'
import audioMixin from '@/mixins/audio'
import FormSimilarChoice from './FormSimilarChoice'

const config = {
  type: 'form-symbol',
  useAudio: true,
}

export default {
  mixins: [exerciseMixin(config), audioMixin()],
  components: {
    FormSimilarChoice,
  },
  async created () {
    await this.init()
    this.enableAudioAutoPlay()
  },
  computed: {
    timeLimit () {
      return 3000
    },
  },
  methods: {
    async initAudio () {
      const audio = this.question.group.audio
      try {
        await this.parseAudio(audio).map(async (file) => {
          const src = require(`!file-loader!@/assets/audio/form-similar/${file.src}`)
          return await this.audioLoad({ src })
        })
      } catch (e) {
        //
      }
    },
  },
}
</script>

<style lang="scss" module>
.root {}
</style>
